import { useState } from "react"
import { Header } from "components/layout/header"
import { MainLayout } from "components/layout/mainLayout"
import { Event as EventBlock, MainPage, Gallery } from 'blocks'

export const ImageGallery = ()=> {
    const [midlwareRegModal, setMidlwareRegModal] = useState(false)
    const [midlwarePhoneModal, setMidlwarePhoneModal] = useState(false)
    const [midlwarePassResetModal, setMidlwarePassResetModal] = useState(false)
    const [midlwareSuccessModal, setMidlwareSuccessModal] = useState(false)

    return (
        <>
            <Header
                isShowMenu
                triggerPhoneModal={() => setMidlwarePhoneModal(true)}
            />
            <MainLayout
                openPhoneModal={midlwarePhoneModal}
                openRegModal={midlwareRegModal}
                openPassResetModal={midlwarePassResetModal}
                openSuccessModal={midlwareSuccessModal}
                setMidlwareRegModal={(e) => {
                    setMidlwareRegModal(e)
                }}
                setMidlwarePhoneModal={(e) => {
                    setMidlwarePhoneModal(e)
                }}
                setMidlwarePassResetModal={(e) => {
                    setMidlwarePassResetModal(e)
                }}
                setMidlwareSuccessModal={(e) => {
                    setMidlwareSuccessModal(e)
                }}
            >
				<MainPage />
            	<EventBlock>
                    <Gallery />
            	</EventBlock>
            </MainLayout>
        </>
    )
}